var map = {
	"./en/strings.json": [
		94752,
		752
	],
	"./es-419/strings.json": [
		63436,
		436
	],
	"./ja/strings.json": [
		35954,
		954
	],
	"./ko/strings.json": [
		64313,
		313
	],
	"./pseudo/strings.json": [
		49425,
		425
	],
	"./pt-BR/strings.json": [
		6974,
		974
	],
	"./zh-Hant/strings.json": [
		43961,
		961
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50713;
module.exports = webpackAsyncContext;